import React, {Component, PropTypes} from 'react';
import _ from 'lodash';
import cx from 'classnames';
import ModalX from '../../../common/svgs/ModalX';
import FlatButton from '../../../common/components/c_FlatButton';
import TextField from '../../../common/components/c_TextField';
import MaskedTextField from '../../../common/components/c_MaskedTextField';
import DropDownMenu from '../../../common/components/c_DropDownMenu';
import {getSchema as getUserSchema} from '../../../models/user';
import QualifyingSpecialists from './qualifyingSpecialists';
import { updateCountry } from '../../../lib/users/updates';

const validationObj = _.omit(getUserSchema(), 'password'); // password gets validated in the next step;

// getting required fields
const getRequiredFieldsArray = schemaObj =>
  Object.keys(_.pickBy(schemaObj, val => val && val.hasOwnProperty('required')));

// gets array of required fields
const requiredFieldsArr = getRequiredFieldsArray(validationObj);

const textFieldHeightAdj = 3;
const textFieldProps = {
    className: 'adminTextField',
    focusColor: '#dbdbdb',
    style: {
      margin: 0,
      width: '100%',
      height: 72 - textFieldHeightAdj
    },
    fieldStyle: {
      fontSize: '14.5px',
      height: 72 - textFieldHeightAdj
    },
    floatingLabelStyle: {
      color: 'rgba(0, 0, 0, 0.498039)'
    },
    errorStyle: {
      display: 'none'
    }
  };
const inlineTextField = _.merge({}, textFieldProps, {
    style: {
      display: 'inline-block',
      width: '32.7%'
    },
    fieldStyle: {
      width: '100%'
    }
  });
const addressTextField = _.merge({}, textFieldProps, {
    style: {
      display: 'inline-block',
      width: '49%'
    },
    fieldStyle: {
      width: '100%'
    }
  });
const dropDownProps = {
    containerStyle: {
      height: '45px',
      width: '100%',
      fontSize: '14.5px'
    },
    labelStyle: {
      padding: '0 15px 0 0'
    },
    underlineStyle: {
      margin: 0,
      borderTopWidth: '1px'
    },
    iconStyle: {
      right: 0
    },
    floatingLabelStyle: {
      left: 0
    }
  };
const inlineDropDown = _.merge({}, dropDownProps, {
  containerStyle: {
    display: 'inline-block',
    transform: 'translateY(-5px)'
  }
});

const textFieldLeft = _.merge({}, inlineTextField, {
  style: {
    width: 'calc(60% - 11px)',
    marginRight: '11px',
    height: '63px'
  },
  fieldStyle: {
    height: '66.4px'
  }
});
const dropDownRight = _.merge({}, inlineDropDown, {
  containerStyle: {
    width: '100%'
  }
});

// specific elements
const nickNameProps = _.merge({}, inlineTextField, {
    style: {
      transform: 'translateY(-2px)'
    }
  });

const middleNameProps = _.merge({}, inlineTextField, {
    style: {
      margin: '0 10px',
      width: 'calc(34.6% - 20px)'
    },
    fieldStyle: {
      width: '100%'
    }
  });
const emailProps = _.merge({}, inlineTextField, {
    style: {
      width: '100%',
    },
    fieldStyle: {
      width: '100%'
    }
  });
const adjustedDropdownProps = _.merge({}, dropDownProps, {
    containerStyle: {
      transform: 'translateY(-2.5px)'
    }
  });

const bestTimeDropdownProps = _.merge({}, dropDownProps, {
    containerStyle: {
      transform: 'translateY(-3px)'
    }
  });

// setting default state out here as constant for clearing
const defaultState = {
  tempApplicant: {
    user: {}
  },
  requiredMissing: [], // for validation
  saveDisabled: true,
  customError: null,
};


export default class EditView extends Component {
  static propTypes = {
    user: PropTypes.object,
    applicant: PropTypes.object,
    stateToggle: PropTypes.func,
    updateApplicant: PropTypes.func,
    updateApplicantQS: PropTypes.func,
    onDeletion: PropTypes.func,
    staticData: PropTypes.object,
    style: PropTypes.object,
    open: PropTypes.bool
  }

  constructor(props) {
    super();
    this.handleUI = ::this.handleUI;
    this.wipeLocalState = ::this.wipeLocalState;
    this.flipBack = props.stateToggle.bind(this, 'edit', 0);
    this.currentUser = props.user;

    this.defaultApplicantState = _.merge(_.cloneDeep(defaultState), {
      tempApplicant: {
        user: {
          id: props.applicant.user.id
        },
        profile: {
          id: props.applicant.profile.id
        }
      }
    });
  }

  state = _.cloneDeep(defaultState)

  componentWillMount() {
    this.wipeLocalState();
  }

  componentWillUpdate(newProps) {
    // reset state on close
    if(this.props.open && !newProps.open) {
      setTimeout(this.wipeLocalState, 137.5); // clear state mid-flip animation
    }
  }

  propValue(fieldName) {
    return this.state.tempApplicant.user.hasOwnProperty(fieldName) ? this.state.tempApplicant.user[fieldName] : _.isObject(this.props.applicant.user[fieldName]) ? this.props.applicant.user[fieldName].id : this.props.applicant.user[fieldName];
  }

  propValueProfile(fieldName) {
    return this.state.tempApplicant.profile.hasOwnProperty(fieldName) ? this.state.tempApplicant.profile[fieldName] : _.isObject(this.props.applicant.profile[fieldName]) ? this.props.applicant.profile[fieldName].id : this.props.applicant.profile[fieldName];
  }

  onQSChange(newValue) {
    const profile = _.merge(this.state.tempApplicant.profile, {
      qualifyingSpecialistId: newValue
    });
    this.setState({
      tempApplicant: _.merge(this.state.tempApplicant, {profile}),
      saveDisabled: false
    });
  }

  onChange(fieldName, event, newValue) {
    const user = !_.isNil(this.props.applicant.user) && _.merge(this.state.tempApplicant.user, {
        [fieldName]: newValue
    });

    // remove from errors array if now valid
    const newRequiredMissing = newValue && ~this.state.requiredMissing.indexOf(fieldName) && this.state.requiredMissing.filter(field => field !== fieldName) || this.state.requiredMissing;

    this.setState({
      tempApplicant: _.merge(this.state.tempApplicant, {user}),
      saveDisabled: !Object.keys(user).length || !!newRequiredMissing.length,
      requiredMissing: newRequiredMissing,
      customError: null,
    });

  }

  onCountryChange = (event, value) => {

    const { countryList } = this.props.staticData;
    const updateUserCountry = updateCountry(countryList);
    const user = updateUserCountry(value || event.target.value);
    _.forEach(user, (val, key) => {
      this.onChange(key, {}, val);
    });

  }

  onBlur(fieldName, event, newValue) {
    // errors for emptying required fields
    if(!newValue && ~requiredFieldsArr.indexOf(fieldName)) {
      this.setState(_.assign(this.state, {
        requiredMissing: this.state.requiredMissing.concat(fieldName),
        saveDisabled: true
      }));
    }
  }

  handleUI(fieldName) {
    return {
      'data-id': fieldName,
      onChange: this.onChange.bind(this, fieldName),
      onBlur: this.onBlur.bind(this, fieldName),
      value: this.propValue(fieldName),
      errorText: !!~this.state.requiredMissing.indexOf(fieldName) && ' ' || undefined // shows or hides error (sticks with text proptype, usually there's an error message actually in the thing)
    };
  }

  handleCountryDropDown() {
    const attributes = this.handleUI('country');
    attributes.onChange = this.onCountryChange;
    attributes.onBlur = this.onCountryChange;
    return attributes;
  }

  disableSave() {
    this.setState(_.merge({}, {saveDisabled: true}));
  }

  onSave = () => {
    this.props.updateApplicant(this.state.tempApplicant, (err, data) => {
      if (err) {
        const customError = _.get(err, 'body.data.items[0]');
        if(_.get(customError, 'errorCode') === 'DUPLICATE_EMAIL') {
          this.setState({customError: customError.message});
        }

        return console.error(err);
      }
      this.disableSave();
      this.flipBack();
    });
  }

  wipeLocalState() {
    this.setState(_.cloneDeep(this.defaultApplicantState));
  }

  renderStateOrCountry(state, props) {
    const {
      stateList = [],
      countryList = []
    } = props.staticData;
    const selectedCountry = this.propValue('country');
    const otherCountry = countryList.find(c => c.subElement === 'Other');

    if (!_.isNil(selectedCountry) && otherCountry && selectedCountry === otherCountry.id) {
      return (
        <TextField floatingLabelText='Specify Country'
                   floatingLabelFixed
                   {...inlineTextField}
                   {...this.handleUI('countryOther')}/>
      );
    }

    return (
      <DropDownMenu floatingLabelText='State'
                    className='state-dropdown'
                    menuItems={stateList}
                    {...adjustedDropdownProps}
                    {...this.handleUI('state')}/>
    );
  }

  render() {
    return (
      <div className='edit-card form-container applicant-information-form'
        data-id={`${this.props.applicant.user.email} edit`}
        key={`Edit Card ${this.props.applicant.profile.id}`}
        style={this.props.style}>
        <ModalX onClick={this.flipBack}/>
        <div className='main-column grid'>
          <h1>Edit Profile Information</h1>
          <div className='row'>
            <div className='col'>
              <TextField floatingLabelText='First Name'
                         floatingLabelFixed
                         {...inlineTextField}
                         {...this.handleUI('firstName')}/>
            </div>
            <div className='col'>
              <TextField floatingLabelText='Middle/Initial'
                         floatingLabelFixed
                         {...middleNameProps}
                         {...this.handleUI('middleName')}/>
            </div>
            <div className='col'>
              <TextField floatingLabelText='Last Name'
                         floatingLabelFixed
                         {...inlineTextField}
                         {...this.handleUI('lastName')}/>
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              <TextField floatingLabelText='Nickname'
                         floatingLabelFixed
                         {...nickNameProps}
                         {...this.handleUI('nickName')}/>
            </div>
            <div className='col'>
              {
                (!!~this.currentUser.roles.indexOf('Admin') || !!~this.currentUser.roles.indexOf('Qualifying Specialist'))
                &&
                  <QualifyingSpecialists
                    profile={this.props.applicant.profile}
                    specialists={this.props.staticData.qualifyingSpecialists}
                    onAssignQS={this.onQSChange.bind(this)}
                  />
              }
            </div>
            <div className='col'>
              <TextField floatingLabelText='Email'
                 floatingLabelFixed
                 className='email-text'
                 disabled={!~this.currentUser.roles.indexOf('Admin')}
                 {...this.handleUI('email')}
                 {...emailProps}/>
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              <DropDownMenu floatingLabelText='Country of Residence'
                className='country-dropdown'
                menuItems={this.props.staticData.countryList}
                {...adjustedDropdownProps}
                {...this.handleCountryDropDown()}/>
            </div>
            <div className='col'>
              <TextField floatingLabelText='Address 1'
                        floatingLabelFixed
                        {...addressTextField}
                        {...this.handleUI('address')}/>
            </div>
            <div className='col'>
              <TextField floatingLabelText='Address 2'
                        floatingLabelFixed
                        {...addressTextField}
                        {...this.handleUI('address2')}/>
            </div>
          </div>
          <div className='row'>
            <div className='col'>
            {
              this.renderStateOrCountry(this.state, this.props)
            }
            </div>
            <div className='col'>
              <div className='row'>
                <div className='col grow-2'>
                  <TextField floatingLabelText='City'
                          floatingLabelFixed
                          {...addressTextField}
                          {...this.handleUI('city')}/>
                </div>
                <div className='col'>
                  <TextField floatingLabelText='Zip Code'
                          floatingLabelFixed
                          maxLength='5'
                          {...addressTextField}
                          {...this.handleUI('zip')}/>
                </div>
              </div>
            </div>
            <div className='col'>
              <div className='row'>
                <div className='col'>
                  <DropDownMenu floatingLabelText='Time Zone'
                                className='timezone-dropdown'
                                menuItems={this.props.staticData.timezoneList}
                                menuStyle={{
                                  overflowX: 'visible',
                                  overflowY: 'visible'
                                }}
                                {...adjustedDropdownProps}
                                {...this.handleUI('timezone')}/>
                </div>
                <div className='col'>
                  <DropDownMenu floatingLabelText='Best Time to Call'
                                className='best-time-dropdown'
                                style={{width: '100%'}}
                                menuItems={this.props.staticData.bestContactTimeList}
                                {...bestTimeDropdownProps}
                                {...this.handleUI('bestContactTime')}/>
                </div>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col'>
              <div className='row'>
                <div className='col grow-2'>
                  <MaskedTextField className='phone-number center-column-1'
                                   floatingLabelText='Phone Number'
                                   floatingLabelFixed
                                   hideMaskChar
                                   mask='(999) 999-9999'
                                   {...textFieldLeft}
                                   {...this.handleUI('phoneNumber1')}/>
                </div>
                <div className='col'>
                  <DropDownMenu
                                floatingLabelText='Type'
                                menuItems={this.props.staticData.phoneTypeList}
                                {...dropDownRight}
                                {...this.handleUI('phoneType1')}/>
                </div>
              </div>
            </div>
            <div className='col'>
              <div className='row'>
                <div className='col grow-2'>
                  <MaskedTextField className='phone-number center-column-1'
                                   floatingLabelText='Phone Number'
                                   floatingLabelFixed
                                   hideMaskChar
                                   mask='(999) 999-9999'
                                   {...textFieldLeft}
                                   {...this.handleUI('phoneNumber2')}/>
                </div>
                <div className='col'>
                  <DropDownMenu
                                floatingLabelText='Type'
                                menuItems={this.props.staticData.phoneTypeList}
                                {...dropDownRight}
                                {...this.handleUI('phoneType2')}/>
                </div>
              </div>
            </div>
            <div className='col'>
              <div className='row'>
                <div className='col grow-2'>
                  <MaskedTextField className='phone-number center-column-1'
                                   floatingLabelText='Phone Number'
                                   floatingLabelFixed
                                   hideMaskChar
                                   mask='(999) 999-9999'
                                   {...textFieldLeft}
                                   {...this.handleUI('phoneNumber3')}/>
                </div>
                <div className='col'>
                  <DropDownMenu
                                floatingLabelText='Type'
                                menuItems={this.props.staticData.phoneTypeList}
                                {...dropDownRight}
                                {...this.handleUI('phoneType3')}/>
                </div>
              </div>
            </div>
          </div>

          <div className='row actions'>
            <div className='col'>
              {
                (!!~this.currentUser.roles.indexOf('Admin'))
                &&
                <FlatButton data-id='delete account button' className='delete-btn'
                            label='Delete Account'
                            onClick={() => this.props.onDeletion()}
                            style={{
                              position: 'absolute',
                              display: 'inline-block',
                              width: '268px',
                              paddingLeft: '30px',
                              paddingRight: '30px',
                              backgroundColor: '#d0011b',
                              border: '1px solid #d0011b',
                              color: '#ffffff',
                            }}
                            hoverStyle={{
                              border: '1px solid #d0011b',
                              color: '#ffffff'
                            }}
                            />
              }
            </div>
            <div className='col grow-2'>
              <div className='row'>
                <div className='col'>
                  <div className={cx('shared-error', {'show-error': this.state.customError || this.state.requiredMissing.length})}>
                    {this.state.customError || 'Must keep required fields populated'}
                  </div>
                </div>
                <div className='col grow-2'>
                  <FlatButton data-id='cancel button' className='cancel-btn'
                              label='Cancel'
                              onClick={this.flipBack}
                              style={{
                                display: 'inline-block',
                                width: '165px',
                                paddingLeft: '30px',
                                paddingRight: '30px',
                                marginRight: '25px',
                              }}/>
                  <FlatButton data-id='save button' disabled={this.state.saveDisabled}
                              className='save-btn'
                              label='Save'
                              onClick={this.onSave}
                              style={{
                                display: 'inline-block',
                                width: '165px',
                                paddingLeft: '30px',
                                paddingRight: '30px',
                                backgroundColor: '#2eb0e3',
                                boxShadow: '0 2px 1px 0 rgba(0,0,0,.41), 0 0 2px 0 rgba(0,0,0,.12)',
                                borderRadius: '2px',
                                border: '0',
                                color: '#ffffff',
                              }}
                              hoverStyle={{
                                color: '#ffffff'
                              }}
                              />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/c_EditCard/index.js